// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"50b6f97c","291":"b5ad9de2","414":"d4c2fe9a","527":"20d9a30c","737":"821376c2","809":"c3f901ff","948":"392011dc"}[chunkId] + ".chunk.js";
};